<template>
    <a
        :href="href"
        :class="[
            'inline-block rounded-t -mb-px text-gray-900 text-sm whitespace-nowrap',
            active ? 'bg-white border border-b-0 font-semibold' : 'hover:text-teal-600',
            !active ? inactiveClass : '',
            padding
        ]"
    >
        <slot />
    </a>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false,
        },
        padding: {
            type: String,
            default: 'py-4 px-6'
        },
        inactiveClass: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: '',
        },
    },
}
</script>
